import { Outlet, ScrollRestoration } from 'react-router-dom';
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';

/**
 * Blog layout — full-width shell matching MainLayout exactly.
 * The Blog page component manages its own internal layout & container.
 */
function BlogLayout() {
    return (
        <div className="flex flex-col min-h-screen bg-neutral-50">
            <Header />
            <main className="flex-1" id="main-content">
                <Outlet />
            </main>
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default BlogLayout;
